import { IConfig } from '@cian/config/shared';

import { UXFB_VISITED_OFFERS_LIMIT } from 'shared/constants/uxfb';

export const getUxfbVisitedOffersLimit = (config: IConfig) => {
  return config.get<number>('uxfeedback.visitedOffersLimit') || UXFB_VISITED_OFFERS_LIMIT;
};
